/*
 * KÖRVONAL — trio tray. The gates, the mode switch and the measurement live in
 * snippets/korvonal-trio-tray.liquid; push both with scripts/push-trio-tray.ts.
 *
 * A sticky bar on collection pages: three slots that fill with the card games
 * already in the cart, a progress line, and the next step toward Shopify's
 * automatic "3 játék −N%" discount. Every figure comes from /cart.js, counted
 * the way that discount counts: units of `kartyajatekok` products. The bar
 * re-reads the cart after every add / quantity change, wherever it happened
 * (grid quick-add, quick view, the drawer, the cart rungs' own writes).
 *
 * The strings reuse the Csomagvarázsló's live wording where one exists
 * (korvonal-bundle-builder.js: "Még N játék a −20%-hoz", "Még X az ingyenes
 * szállításig", "−20% · ingyenes szállítás", "X-tal olcsóbb, mint külön").
 * Copy signed off by the operator 2026-10-15.
 */
(function () {
  'use strict';

  var root = document.getElementById('kv-trio-tray');
  if (!root || root.dataset.kvInit) return;
  root.dataset.kvInit = '1';

  if (root.dataset.mode === 'preview') {
    var pv = null;
    try {
      var q = new URLSearchParams(location.search).get('triotray');
      if (q === '0' || q === 'off') { sessionStorage.removeItem('kvtt_preview'); q = null; }
      else if (q) sessionStorage.setItem('kvtt_preview', '1');
      pv = q || sessionStorage.getItem('kvtt_preview');
    } catch (e) {}
    if (!pv) return;
  }

  var TRIO = parseInt(root.dataset.trio, 10) || 0;
  var THRESHOLD = parseInt(root.dataset.threshold, 10) || 0; // whole Ft; 0 = no free tier
  var COLL = root.dataset.collection || '';
  var SLOTS = 3;
  var SHELF = {};
  (root.dataset.shelfIds || '').split(',').forEach(function (id) { if (id) SHELF[id] = true; });
  if (!TRIO) return;

  // Same workspace token + endpoint as the bundle grid and the cart rungs.
  var EP = 'https://api.korvonal.com/api/storefront-events/cmpismusd0000b965jxyb4r46';
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); return v; } catch (e) { return null; } }
  function uuid() { return (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'v-' + Date.now() + '-' + Math.random().toString(16).slice(2); }
  var visitorId = ls('otto_visitor_id') || uuid(); ls('otto_visitor_id', visitorId);
  var day = new Date().toISOString().slice(0, 10);
  // Deduped per visitor × collection × day by the event id.
  function track(name, data) {
    try {
      fetch(EP, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ events: [{ id: name + ':' + visitorId + ':' + COLL + ':' + day, eventName: name,
          clientId: visitorId, visitorId: visitorId, occurredAt: new Date().toISOString(), url: location.href, data: data }] })
      }).catch(function () {});
    } catch (e) {}
  }

  function money(cents) {
    return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Ft';
  }
  function thumb(src) {
    if (!src) return '';
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=96';
  }
  function esc(s) {
    return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  // ---- trio-tray-v1 (lib/experiments/registry.ts) ---------------------------
  // Mode `ab`: a sticky draw per browser, 70% tray / 30% control (operator,
  // 2026-10-16: "cost is less if it works"). Both arms fire experiment_exposure
  // and stamp `_experiment_triotray` = "trio-tray-v1:<arm>" for the order read;
  // control then renders nothing. ?ttab=control|tray shows an arm without
  // counting. Off the published theme the A/B events go to window.__kvTtAb and
  // the console instead, so a preview-theme check writes nothing. Same machinery
  // as the bestsellers test in korvonal-bundle-grid.js.
  var AB = { key: 'trio-tray-v1', attr: '_experiment_triotray', share: 0.7 };
  var arm = null;
  function isMain() { try { return !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main'); } catch (e) { return false; } }
  function sendAb(name, id) {
    var ev = { id: id, eventName: name, clientId: visitorId, visitorId: visitorId,
      occurredAt: new Date().toISOString(), url: location.href, data: { experimentKey: AB.key, variant: arm } };
    if (!isMain()) {
      try { (window.__kvTtAb = window.__kvTtAb || []).push(ev); console.log('[kv-trio-tray-ab]', JSON.stringify(ev)); } catch (e) {}
      return;
    }
    try {
      fetch(EP, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ events: [ev] }) }).catch(function () {});
    } catch (e) {}
  }
  function cartCookie() { var x = document.cookie.match(/(?:^|;\s*)cart=([^;]*)/); return x ? x[1] : ''; }
  // Re-stamped while PickupBird's on-load cart write can replace the cart (same
  // watcher as the bestsellers test and snippets/korvonal-home-v2-ab.liquid).
  function stamp(left) {
    var value = AB.key + ':' + arm, attrs = {};
    attrs[AB.attr] = value;
    if (!isMain()) { sendAb('cart_stamp', 'stamp'); return; }
    try {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs }) }).then(function () {
        if (left) watch(left, null, Date.now() + 20000);
      }).catch(function () {});
    } catch (e) {}
    function watch(n, seen, end) {
      var t = setInterval(function () {
        var c = cartCookie();
        if (c === seen) { if (Date.now() > end) clearInterval(t); return; }
        clearInterval(t);
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          if (cart && cart.attributes && cart.attributes[AB.attr] === value) watch(n, c, end);
          else stamp(n - 1);
        }).catch(function () {});
      }, 500);
    }
  }
  if (root.dataset.mode === 'ab') {
    var forcedArm = (/[?&]ttab=(control|tray)(?:&|$)/.exec(location.search) || [])[1] || null;
    var counted = false;
    arm = forcedArm;
    if (!forcedArm) {
      arm = ls('kv_tt_ab_arm');
      if (arm !== 'control' && arm !== 'tray') {
        // Only where the choice can be kept: a visitor who flips arm between
        // page views is worse than one not tested.
        var pick = Math.random() < AB.share ? 'tray' : 'control';
        arm = ls('kv_tt_ab_arm', pick) === pick && ls('kv_tt_ab_arm') === pick ? pick : null;
      }
      counted = !!arm;
    }
    if (!arm) return; // no storage: untested, and sees the store without the tray
    if (counted) {
      var fired = 'kv_tt_ab_exposed' + (isMain() ? '' : ':preview');
      if (!ls(fired)) {
        ls(fired, '1');
        sendAb('experiment_exposure', AB.key + ':' + visitorId);
      }
      stamp(2);
    }
    if (arm === 'control') return;
  }

  var css = document.createElement('link');
  css.rel = 'stylesheet';
  css.href = root.dataset.css;
  document.head.appendChild(css);

  var slotsHtml = '';
  for (var s = 0; s < SLOTS; s++) slotsHtml += '<li class="kv-tt__slot"><span>' + (s + 1) + '</span></li>';
  root.innerHTML =
    '<div class="kv-tt__card">' +
      '<div class="kv-tt__bar" aria-hidden="true"><i></i></div>' +
      '<div class="kv-tt__row">' +
        '<ol class="kv-tt__slots" aria-hidden="true">' + slotsHtml + '</ol>' +
        '<strong class="kv-tt__main"><span></span></strong>' +
        '<span class="kv-tt__sub"></span>' +
        '<button type="button" class="kv-tt__cart">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M5 8h14l-1.2 11.1a1 1 0 0 1-1 .9H7.2a1 1 0 0 1-1-.9L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>' +
          '<span class="kv-tt__count"></span>' +
        '</button>' +
        '<span class="kv-tt__live" aria-live="polite"></span>' +
      '</div>' +
    '</div>';

  var bar = root.querySelector('.kv-tt__bar i');
  var slots = root.querySelectorAll('.kv-tt__slot');
  var main = root.querySelector('.kv-tt__main span');
  var sub = root.querySelector('.kv-tt__sub');
  var cartBtn = root.querySelector('.kv-tt__cart');
  var count = root.querySelector('.kv-tt__count');
  var live = root.querySelector('.kv-tt__live');
  var shown = false;
  var ruleOff = false;
  var parked = false; // the footer is on screen

  // One switch for "the tray is on screen": slid in, focusable, and the
  // theme's add-to-cart popup lifted above it.
  function setVisible() {
    var on = shown && !ruleOff && !parked;
    root.classList.toggle('is-in', on);
    root.inert = !on;
    document.documentElement.classList.toggle('kv-tt-on', on);
  }
  var prevUnits = -1;
  var lastUnits = 0;

  function render(cart) {
    if (ruleOff) return;
    var units = 0, saving = 0, expected = 0, pics = [];
    // /cart.js lists the newest line first; slots fill in the order games went in.
    (cart.items || []).slice().reverse().forEach(function (i) {
      if (!SHELF[i.product_id]) return;
      units += i.quantity;
      saving += Math.max(0, i.original_line_price - i.final_line_price);
      expected += Math.round(i.original_line_price * TRIO / 100);
      for (var n = 0; n < i.quantity && pics.length < SLOTS; n++) pics.push({ src: thumb(i.image), alt: i.product_title });
    });
    var full = units >= SLOTS;
    // The cart is the proof. With three games in it, the shelf lines must carry
    // exactly the trio's cut (1 Ft per unit of rounding slack). Anything else
    // means the rule is not what the cart applies: the trio paused for a
    // sitewide promo, a 2+1 taking its place, a code winning instead. Then the
    // tray says nothing for the rest of the page view rather than a wrong %.
    if (full && Math.abs(saving - expected) > units * 100) {
      ruleOff = true;
      setVisible();
      root.hidden = true;
      return;
    }
    var freeShip = !!(THRESHOLD && cart.total_price >= THRESHOLD * 100);
    var toFree = THRESHOLD ? Math.max(0, THRESHOLD * 100 - cart.total_price) : 0;

    for (var k = 0; k < SLOTS; k++) {
      var el = slots[k];
      var p = pics[k];
      el.classList.toggle('is-filled', !!p);
      if (p) {
        var more = (k === SLOTS - 1 && units > SLOTS) ? '<span class="kv-tt__more">+' + (units - SLOTS + 1) + '</span>' : '';
        el.innerHTML = '<img src="' + esc(p.src) + '" alt="" width="44" height="44" loading="lazy">' + more;
      } else {
        el.innerHTML = '<span>' + (k + 1) + '</span>';
      }
      if (prevUnits >= 0 && k >= prevUnits && k < units) {
        el.classList.remove('is-new');
        void el.offsetWidth; // restart the animation on a repeat add
        el.classList.add('is-new');
      }
    }
    prevUnits = units;
    lastUnits = units;

    bar.style.transform = 'scaleX(' + (Math.min(units, SLOTS) / SLOTS) + ')';
    root.classList.toggle('is-full', full);

    var pct = '−' + TRIO + '%';
    if (units === 0) {
      main.textContent = 'Bármelyik 3 játék ' + pct;
      sub.textContent = THRESHOLD ? 'ingyenes szállítással' : '';
    } else if (!full) {
      main.textContent = 'Még ' + (SLOTS - units) + ' játék a ' + pct + '-hoz';
      sub.textContent = freeShip ? 'ingyenes szállítás ✓' : THRESHOLD ? 'Még ' + money(toFree) + ' az ingyenes szállításig' : '';
    } else {
      main.textContent = pct + (freeShip ? ' · ingyenes szállítás' : '');
      sub.textContent = saving ? money(saving) + '-tal olcsóbb, mint külön' : '';
    }
    sub.hidden = !sub.textContent;
    root.classList.toggle('no-sub', sub.hidden);
    live.textContent = main.textContent + (sub.textContent ? '. ' + sub.textContent : '');

    var n = cart.item_count || 0;
    count.textContent = n;
    count.hidden = !n;
    cartBtn.setAttribute('aria-label', n ? 'Kosár, ' + n + ' termék' : 'Kosár');

    if (!shown) {
      shown = true;
      root.hidden = false;
      measure();
      if (window.ResizeObserver) new ResizeObserver(measure).observe(root.querySelector('.kv-tt__card'));
      else window.addEventListener('resize', measure);
      requestAnimationFrame(function () { requestAnimationFrame(setVisible); });
      track('trio_tray_seen', { units: units, collection: COLL, mode: root.dataset.mode, arm: arm });
    }
  }

  // The tray steps aside while the footer is on screen, so it never covers the
  // legal lines and the page needs no bottom padding (padding showed as a band
  // of body colour under the dark footer; operator 2026-10-15).
  // Every section of the footer group is watched: the first one is an empty
  // 0px wrapper on the live theme and never "enters" the viewport.
  var feet = document.querySelectorAll('.shopify-section-group-footer-group');
  if (!feet.length) feet = document.querySelectorAll('footer');
  function checkFoot() {
    parked = Array.prototype.some.call(feet, function (f) {
      if (!f.offsetHeight) return false;
      var r = f.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    });
    setVisible();
  }
  if (feet.length && window.IntersectionObserver) {
    var io = new IntersectionObserver(checkFoot);
    Array.prototype.forEach.call(feet, function (f) { io.observe(f); });
  }

  // The tray's footprint (card + bottom gap), for the theme's "bekerült a
  // kosaradba" popup, which would otherwise land on the tray's cart button
  // (both are bottom-anchored).
  function measure() {
    var card = root.querySelector('.kv-tt__card');
    var h = card.offsetHeight + (parseFloat(getComputedStyle(root).paddingBottom) || 0);
    document.documentElement.style.setProperty('--kv-tt-h', Math.ceil(h) + 'px');
  }

  var timer = null;
  var inflight = false;
  var again = false;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (inflight) { again = true; return; }
      inflight = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {})
        .then(function () {
          inflight = false;
          if (again) { again = false; refresh(); }
        });
    }, 120);
  }

  cartBtn.addEventListener('click', function () {
    track('trio_tray_click', { units: lastUnits, collection: COLL });
    var drawer = document.getElementById('site-cart-sidebar');
    if (drawer && typeof drawer.show === 'function') drawer.show();
    else location.href = '/cart';
  });

  // The theme dispatches a NON-bubbling `add-to-cart` on <product-form> and
  // `cart-updated` on <cart-form>: only a capturing listener on the document
  // hears both (korvonal-cart-rungs.js learned this the hard way).
  document.addEventListener('add-to-cart', refresh, true);
  document.addEventListener('cart-updated', refresh, true);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  refresh();
})();
